import { loadUserData, tokenExpiredPopup, logoutTokenExpired } from 'features/Auth/Auth.actions'
import { getBillingAccounts } from 'features/Billing/Billing.actions'

export default store => {
  // Load the user data
  const { auth } = store.getState()

  const expirationTime = new Date(auth.expiration).getTime()
  const nowTime = new Date().getTime()
  const isExpired = auth.expiration && expirationTime < nowTime
  const timeTilExpired = expirationTime - nowTime

  if (isExpired) {
    // Logout the user of the token is expired
    store.dispatch(logoutTokenExpired())
  } else if (auth.token) {
    // Load the user data
    store.dispatch(tokenExpiredPopup(timeTilExpired))
    store.dispatch(loadUserData())
    store.dispatch(getBillingAccounts())
  }
}



// WEBPACK FOOTER //
// ./src/app/init/initAuth.js